import { render, staticRenderFns } from "./referrer-domain.vue?vue&type=template&id=34c5a414&"
import script from "./referrer-domain.vue?vue&type=script&lang=ts&"
export * from "./referrer-domain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports